import { render } from "./delegate.vue?vue&type=template&id=1ad7062a"
import script from "./delegate.vue?vue&type=script&lang=ts"
export * from "./delegate.vue?vue&type=script&lang=ts"
script.render = render

export default script